import React, { Component } from 'react'
import { connect } from 'react-redux'

import BkFlowStepsDefault from './layouts/BkFlowStepsDefault'

import setActiveStep from '../../../actions/activeStepActions'
import getSteps from '../../../utilities/content/getSteps'

import yn from 'yn'

if (process.env.REACT_APP_COMPONENT_NAVIGATION === 'default') {
	require('../../../styles/css/components/stepper/bk-flow-steps.css')
}

class BkFlowSteps extends Component {
	constructor(props) {
		super(props)
		this.state = {
		}
	}

	getSteps = () => {
		const { configData } = this.props

		const hotelLabels = configData.hotel.labels[0],
				  componentSteps = []

		// Render steps with translated values
		if (
			yn(process.env.REACT_APP_COMPONENT_PRE_ENHANCEMENTS) &&
			yn(process.env.REACT_APP_COMPONENT_POST_ENHANCEMENTS)
		) {
			componentSteps.push(hotelLabels.rooms, hotelLabels.enhancements, hotelLabels.payment, hotelLabels.confirmation)
		} else if ( yn(process.env.REACT_APP_COMPONENT_PRE_ENHANCEMENTS) ) {
			componentSteps.push(hotelLabels.rooms, hotelLabels.enhancements, hotelLabels.payment, hotelLabels.confirmation)
		} else if ( yn(process.env.REACT_APP_COMPONENT_POST_ENHANCEMENTS) ) {
			componentSteps.push(hotelLabels.rooms, hotelLabels.payment, hotelLabels.enhancements, hotelLabels.confirmation)
		} else {
			componentSteps.push(hotelLabels.rooms, hotelLabels.payment, hotelLabels.confirmation)
		}

		return componentSteps
	}

	render() {
		const {
			configData,
			activeStep,
			handleStepperNavigation
		} = this.props

		let hotelLabels = configData.hotel.labels[0]

		const steps = getSteps(hotelLabels)

		return (
			<div className="bk-flow-steps">
				<BkFlowStepsDefault
					activeStep={ activeStep }
					handleStepperNavigation={ handleStepperNavigation }
					hotelLabels={hotelLabels}
					steps={ steps }
				/>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		configData: state.configData.configuration,
		activeStep: state.activeStepData.activeStep
	}
}

const mapDispatchToProps = dispatch => ({
	handleStepperNavigation(index) {
		return (
			dispatch(setActiveStep(index))
		)
	}
})

export default connect(mapStateToProps, mapDispatchToProps)(BkFlowSteps)


// WEBPACK FOOTER //
// ./src/components/structure/stepper/BkFlowSteps.js